
import Vue from 'vue'
import App from './app.vue'
import store from './store'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import '../theme/index.css'

Vue.use( ElementUI, { locale } )

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue( { components: { App }, store }).$mount('app')
})